import { createAction, createReducer } from 'redux-act';

import { loadRegionalCenters, loadRegions } from '../services/location';

export interface ILocation {
  id: number;
  name: string;
  fullName?: string;
  regionName?: string;
  nameLocative?: string;
  nameGenitive?: string;
  route: string;
  alias: string;
  localityType: string;
  shortLocationType: string;
  latitude: number;
  longitude: number;
}

export interface IState {
  regions: {
    [id: number]: ILocation;
  };
  centers: {
    [id: number]: ILocation;
  };
  currentLocation: ILocation;
}

const initialState: IState = {
  regions: {},
  centers: {},
  currentLocation: {
    id: 83,
    name: 'Москва',
    fullName: 'г Москва',
    nameLocative: 'в Москве',
    nameGenitive: 'Москвы',
    route: '6.83.',
    alias: 'moskva',
    localityType: 'город',
    shortLocationType: 'г.',
    latitude: 55.753676,
    longitude: 37.619899,
  },
};

export const setCurrentLocation = createAction<ILocation>('locations/set');
export const setLocations = createAction<{ regions: IState['regions']; centers: IState['centers'] }>(
  'locations/current/set',
);

const reducer = createReducer<IState>({}, initialState)
  .on(setCurrentLocation, (state, payload) => {
    return {
      ...state,
      currentLocation: payload,
    };
  })
  .on(setLocations, (state, payload) => {
    return {
      ...state,
      centers: payload.centers,
      regions: payload.regions,
    };
  });

export const fetchRegionsWithCenters = () => {
  return async (dispatch) => {
    let centers: ILocation[] = [];
    let regions: ILocation[] = [];

    try {
      [centers, regions] = await Promise.all([loadRegionalCenters(), loadRegions()]);
    } catch (e) {
      console.error(e);
    }

    dispatch(setLocations({ centers, regions }));
  };
};

export default reducer;
